var map = {
	"./add-black-24dp.svg": "ddbc",
	"./add-blue-24dp.svg": "6be2",
	"./add_a_photo-blue-24dp.svg": "a721",
	"./arrow_back-black-18dp.svg": "716c",
	"./arrows-select-black.svg": "75e6",
	"./avatars/ambassador.svg": "8252",
	"./avatars/angel.svg": "1753",
	"./avatars/baby-angel.svg": "5b38",
	"./avatars/elite-map-maker.svg": "5278",
	"./avatars/guard-angel.svg": "e9b9",
	"./avatars/knight-angel.svg": "0540",
	"./avatars/map-maker.svg": "ea10",
	"./avatars/map-validator.svg": "3e8e",
	"./avatars/newbie-map-maker.svg": "77ad",
	"./avatars/royal-angel.svg": "44bb",
	"./bus-stop.svg": "4ef9",
	"./check-blue-16dp.svg": "ad6a",
	"./close-black-24dp.svg": "c1e0",
	"./close-blue-16dp.svg": "65d5",
	"./close-white-24dp.svg": "1f76",
	"./content_copy-black-24dp.svg": "00ff",
	"./delete-black-24dp.svg": "af4e",
	"./delete-red-24dp.svg": "a9f0",
	"./dollars.svg": "3ca7",
	"./drag_handle_black_24dp.svg": "fa2e",
	"./edit-approved.svg": "6a1a",
	"./edit-blue-16dp.svg": "ff5b",
	"./edit-not-approved.svg": "2176",
	"./edit-standby.svg": "5526",
	"./expand_more-black-24dp.svg": "8d8b",
	"./expand_more-blue-18dp.svg": "085c",
	"./fire-hydrant.svg": "ba55",
	"./gas-station-black-24dp.svg": "4531",
	"./happy-angel.svg": "aaf2",
	"./info-grey-18dp.svg": "a595",
	"./layers.svg": "d8d5",
	"./list.svg": "f26b",
	"./location_on-black-18dp.svg": "3d76",
	"./location_on-blue-18dp.svg": "5e5d",
	"./map-blue-24dp.svg": "3886",
	"./meter.svg": "642c",
	"./notifications-black-24dp.svg": "9ecd",
	"./parking-sign.svg": "cc91",
	"./person_outline_black_24dp.svg": "bf72",
	"./refresh-black-24dp.svg": "bb8d",
	"./refresh-blue-24dp.svg": "dda8",
	"./report_black_24dp.svg": "13fb",
	"./rotate-blue-16dp.svg": "f93f",
	"./ruler.svg": "2ca6",
	"./schedule_black_24dp.svg": "7454",
	"./sent.svg": "a96f",
	"./settings.svg": "09a5",
	"./sort_blue_24dp.svg": "de8b",
	"./spotangels-logo-editor.svg": "5668",
	"./spotangels.svg": "e1a5",
	"./visibility_black_24dp.svg": "8f0a",
	"./visibility_off_black_24dp.svg": "f596"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";